module.exports = __webpack_public_path__ + "img/ServiceIndustrial.0a394c75.svg";